import React, { FC } from 'react';
import { FormattedNumber } from 'react-intl';
import FormattedDateTime from '../format/FormattedDateTime';
import Chart from './Chart';
import color from '../../config/color';
import './TickerChart.css';
import { Ticker } from '../../interfaces/interfaces';

interface Props {
  ticker: Ticker;
}

const TickerChart: FC<Props> = ({ ticker }) => {
  const lastEntry = ticker.ticker[ticker.ticker.length - 1];
  const percentChanged = lastEntry.price / ticker.previousClose - 1;
  return (
    <div>
      <div className="ticker-info">
        <div>
          <div className="ticker-title">Ticker</div>
          <div className="ticker-content">OSEBX</div>
        </div>
        <div>
          <div className="ticker-title">Siste kurs</div>
          <div className="ticker-content">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={lastEntry.price}
            />
          </div>
        </div>
        <div className="hide-on-smartphone">
          <div className="ticker-title">Oppdatert</div>
          <div className="ticker-content">
            <FormattedDateTime
              timestamp={new Date(lastEntry.timestamp)}
              type="Share"
              showClockPrefix={false}
            />
          </div>
        </div>
        <div>
          <div className="ticker-title">+/- %</div>
          <div
            className={`ticker-content ${color.getClassName(percentChanged)}`}
          >
            <FormattedNumber // eslint-disable-next-line
              style="percent"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={percentChanged}
            />
          </div>
        </div>
      </div>
      <Chart container="ticker-chart" chartKey="ticker" data={ticker} />
    </div>
  );
};

export default TickerChart;
